module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic61.fbe36d9.woff2";